import eventEmitter, { EVENTS } from 'eventEmitter';
import store from '../store';
import { logout } from '../slices/auth';

eventEmitter.on(EVENTS.API.UNAUTHORIZED_ACCESS_REQUEST, () => {
  store.dispatch(logout());
});
